var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ../js/~/lodash/_Uint8Array.js
// module id = 334
// module chunks = 0